/**
 * OrientationToggle - Portrait/Landscape orientation selector
 *
 * Toggle buttons for module orientation selection.
 */

import React from 'react';

type Orientation = 'portrait' | 'landscape';

interface OrientationToggleProps {
  value: Orientation;
  onChange: (orientation: Orientation) => void;
}

export function OrientationToggle({ value, onChange }: OrientationToggleProps) {
  return (
    <div>
      <label className="block font-semibold text-gray-700 mb-1">Orientation</label>
      <div className="flex gap-2">
        <button
          onClick={() => onChange('portrait')}
          className={`flex-1 py-1 px-2 rounded text-xs ${
            value === 'portrait'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
          }`}
        >
          Portrait
        </button>
        <button
          onClick={() => onChange('landscape')}
          className={`flex-1 py-1 px-2 rounded text-xs ${
            value === 'landscape'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
          }`}
        >
          Landscape
        </button>
      </div>
    </div>
  );
}

export default OrientationToggle;
